module.exports = __webpack_public_path__ + "img/text.7b1e2701.png";